import { FormProvider, useFormContext } from 'react-hook-form';
import 'react-quill/dist/quill.snow.css';
import { useModal } from '@shape-ds/components';
import { TextEditorModal } from './TextEditorModal';
import './TextEditorModal.scss';

export type TextEditorProps = {
  label?: string;
  name: string;
  placeholder: string;
  isDisabled?: boolean;
  'data-testid'?: string;
  isRequired?: boolean;
  onSubmit?: () => void;
};

export const useTextEditorModal = ({
  name,
  placeholder,
  isDisabled,
  'data-testid': dataTestId,
  label,
  isRequired,
  onSubmit: parentOnSubmit,
}: TextEditorProps) => {
  const { openModal, closeModal } = useModal();
  const methods = useFormContext();
  const caseName = methods.getValues('name');

  const handleSubmit = () => {
    try {
      const isValid = methods.trigger();
      if (!isValid) return;
      if (parentOnSubmit) parentOnSubmit();
      closeModal();
    } catch (error) {
      console.error('Error submitting the form:', error);
    }
  };

  return {
    openTextEditorModal: () =>
      openModal(
        <FormProvider {...methods}>
          <TextEditorModal
            name={name}
            placeholder={placeholder}
            isDisabled={isDisabled}
            data-testid={dataTestId}
            label={label}
            isRequired={isRequired}
            caseName={caseName}
            closeModal={closeModal}
            onSubmit={handleSubmit}
          />
        </FormProvider>,
        {
          isFullScreenToggle: true,
          closeButtonClassName: 'text-editor-modal-close-icon',
          className: 'text-editor-modal',
        },
      ),
  };
};
